import React from 'react';

import { AccordionItem } from '@radix-ui/react-accordion';
import { useTranslation } from 'react-i18next';

import { Chip, ChipSize } from '@pkg/components/Sections/Profile/Chip';
import { FilterAction, FilterContent, FilterHeading, type FilterIndex } from '@pkg/components/Sections/Profile/Filters';
import { OWNERSHIPS } from '@pkg/hooks';
import { NftFiltersKey, useNftFilter } from '@pkg/providers';

import { type GroupItemOwnership } from '@app/client/common/structs/groups/groups';

const FILTER_KEY = NftFiltersKey.Ownership;
const reversedOwnerships = OWNERSHIPS;

export function GroupFilterOwnership({ value }: FilterIndex) {
    const { t: translate } = useTranslation(['groups']);
    const [filters, setFilters] = useNftFilter();

    function handleUpdateOwnership(ownership: GroupItemOwnership) {
        if (filters.hasSomeValue(FILTER_KEY, ownership)) {
            filters.remove(FILTER_KEY, ownership);
        } else {
            filters.append(FILTER_KEY, ownership);
        }

        setFilters(filters);
    }

    const ownershipItems = reversedOwnerships.map((ownership) => (
        <FilterAction
            key={`GroupFilterOwnership-${ownership}`}
            pressed={filters.hasSomeValue(FILTER_KEY, ownership)}
            onAction={() => handleUpdateOwnership(ownership)}
        >
            <Chip size={ChipSize.Small}>
                <Chip.Interior>
                    <Chip.Label content={translate(`groups_filter_ownership_${ownership.toLowerCase()}`)} />
                </Chip.Interior>
            </Chip>
        </FilterAction>
    ));

    return (
        <AccordionItem value={value}>
            <FilterHeading disableUpperCase>{translate('groups_filter_ownership_title')}</FilterHeading>
            <FilterContent direction="row">{ownershipItems}</FilterContent>
        </AccordionItem>
    );
}
